(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ezm-next-chapter"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'ezm-next-chapter';
  if (!window.customElements || customElements.get(tag)) return;

  class EZMNextChapter extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.setupFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        try { this.setup(); }
        catch (_) { this.cleanup(); }
      });
    }

    disconnectedCallback() { this.cleanup(); }

    setup() {
      this.cleanup();
      this.events = new AbortController();
      const { signal } = this.events;
      this.reveals = [...this.querySelectorAll('[data-next-reveal]')];
      this.videos = [...this.querySelectorAll('video[data-next-video]')];
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.configureMotion();
      this.preference.addEventListener('change', () => this.configureMotion(), { signal });

      this.addEventListener('focusin', (event) => this.revealAncestors(event.target), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        this.revealAncestors(event.target);
        event.target.querySelectorAll?.('[data-next-reveal]').forEach((node) => this.reveal(node));
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseVideos();
      }, { signal });
      window.addEventListener('pagehide', () => this.pauseVideos(), { signal });

      if ('IntersectionObserver' in window && this.videos.length) {
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (!isIntersecting || document.hidden) this.pause(target);
          });
        }, { threshold: 0 });
        this.videos.forEach((video) => this.videoObserver.observe(video));
      }
    }

    configureMotion() {
      this.revealObserver?.disconnect();
      this.classList.remove('next-motion');
      if (this.dataset.motion !== 'true' || this.preference.matches || !('IntersectionObserver' in window)) {
        this.reveals.forEach((node) => this.reveal(node));
        return;
      }
      try {
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting) this.reveal(target);
          });
        }, { rootMargin: '0px 0px -24px 0px', threshold: 0 });
        this.reveals.forEach((node) => {
          if (!node.classList.contains('is-visible')) this.revealObserver.observe(node);
        });
        // Add the hiding class only after observation is ready. No JS means visible content.
        this.classList.add('next-motion');
        this.revealAncestors(document.activeElement);
      } catch (_) {
        this.revealObserver?.disconnect();
        this.classList.remove('next-motion');
        this.reveals.forEach((node) => node.classList.add('is-visible'));
      }
    }

    reveal(node) {
      node.classList.add('is-visible');
      this.revealObserver?.unobserve(node);
    }

    revealAncestors(target) {
      if (!(target instanceof Element) || !this.contains(target)) return;
      let node = target.closest('[data-next-reveal]');
      while (node && this.contains(node)) {
        this.reveal(node);
        node = node.parentElement?.closest('[data-next-reveal]');
      }
    }

    pause(video) {
      try { video.pause(); } catch (_) { /* Keep content usable if a media element is unavailable. */ }
    }

    pauseVideos() { this.videos?.forEach((video) => this.pause(video)); }

    cleanup() {
      cancelAnimationFrame(this.setupFrame);
      this.events?.abort();
      this.revealObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.pauseVideos();
      this.classList.remove('next-motion');
    }
  }

  customElements.define(tag, EZMNextChapter);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezm-story-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'ezm-story-cinema';
  if (customElements.get(tag)) return;

  class EZMStoryCinema extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.setupFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        try {
          this.setup();
        } catch (error) {
          this.cleanup();
          this.classList.remove('esh-tabs-ready', 'esh-collection-open');
          this.querySelector('.esh-back')?.setAttribute('hidden', '');
          console.warn('EZM Story: native images, videos and collection controls remain available.', error);
        }
      });
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      cancelAnimationFrame(this.setupFrame);
      cancelAnimationFrame(this.frame);
      this.frame = null;
      cancelAnimationFrame(this.menuScrollFrame);
      this.menuScrollFrame = null;
      this.events?.abort();
      this.restoreCinemaControls();
      this.headerResize?.disconnect();
      this.headerChanges?.disconnect();
      this.viewportObserver?.disconnect();
      this.viewportObserver = null;
      this.revealObserver?.disconnect();
      this.cancelAnimations();
      this.pauseVideos();
      this.querySelector('[data-product-peek]')?.removeAttribute('data-visible');
      this.classList.remove('esh-motion', 'esh-tabs-ready', 'esh-collection-open');
    }

    setup() {
      this.cleanup();
      this.events = new AbortController();
      const { signal } = this.events;
      this.hero = this.querySelector('.esh-hero');
      this.items = [...this.querySelectorAll('.esh-item')];
      this.videos = [...this.querySelectorAll('.esh-feature-video')];
      this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
      this.animationAllowed = this.dataset.animate !== 'false';
      this.headerFallback = Math.max(0, Number(this.dataset.headerFallback) || 0);
      this.headerMode = this.dataset.headerMode || 'auto';
      this.cssValues = new Map();
      this.rootVisible = this.inViewport(this);
      this.heroVisible = !!this.hero && this.inViewport(this.hero);

      this.setupCollections(signal);
      this.setupCinemaVideo(signal);
      this.setupCinemaMenu(signal);
      this.observeHeader();
      this.setupViewport();
      this.configureMotion();

      this.motionPreference.addEventListener('change', () => {
        this.configureMotion();
      }, { signal });
      // Capture covers both the page and themes with their own scroll container.
      document.addEventListener('scroll', () => {
        if (!this.viewportObserver) {
          this.rootVisible = this.inViewport(this);
          this.heroVisible = !!this.hero && this.inViewport(this.hero);
          this.cinemaVisible = !!this.cinemaVideo && this.inViewport(this.cinemaVideo);
          this.videos.forEach((video) => { if (!this.inViewport(video)) this.pauseVideo(video); });
          this.syncCinemaPlayback();
        }
        if (this.rootVisible) this.scheduleFrame();
      }, { signal, passive: true, capture: true });
      const resize = () => { this.layoutDirty = true; this.scheduleFrame(); };
      window.addEventListener('resize', resize, { signal, passive: true });
      window.visualViewport?.addEventListener('resize', resize, { signal, passive: true });
      document.addEventListener('eurus:sticky-header-moved', () => {
        this.observeHeader();
        this.scheduleFrame();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseVideos();
        else { this.layoutDirty = true; this.scheduleFrame(); this.syncCinemaPlayback(); }
      }, { signal });
      this.addEventListener('click', (event) => this.followAnchor(event), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const blockId = String(event.detail?.blockId);
        const slideIndex = this.cinemaSlides.findIndex((slide) => slide.dataset.blockId === blockId);
        if (slideIndex >= 0) {
          this.selectCinemaSlide(slideIndex, { animate: false });
          this.hero?.scrollIntoView({ behavior: 'instant', block: 'start' });
          return;
        }
        const index = this.items.findIndex((item) => item.dataset.blockId === blockId);
        if (index < 0) return;
        this.items[index].setAttribute('data-editor-selected', '');
        this.items[index].classList.add('esh-revealed');
        this.openCollection(index, { scroll: true, animate: false });
      }, { signal });
      document.addEventListener('shopify:block:deselect', (event) => {
        this.items.find((item) => item.dataset.blockId === String(event.detail?.blockId))?.removeAttribute('data-editor-selected');
      }, { signal });
      this.scheduleFrame();
      this.dispatchEvent(new CustomEvent('ezm:story-ready', { bubbles: true }));
    }

    setupCollections(signal) {
      this.explorer = this.querySelector('.esh-explorer');
      this.cards = [...this.querySelectorAll('[data-open-collection]')];
      this.inputs = [...this.querySelectorAll('.esh-tab-input')];
      this.panels = [...this.querySelectorAll('.esh-panel')];
      this.entryLinks = [...this.querySelectorAll('[data-cinema-collection]')].filter((link) =>
        this.items.some((item) => item.dataset.blockId === link.dataset.cinemaCollection)
      );
      this.tabBar = this.querySelector('.esh-tab-heads');
      this.collectionStatus = this.querySelector('.esh-collection-status');
      if (!this.explorer || this.inputs.length !== this.panels.length || this.cards.length !== this.inputs.length || this.items.length !== this.inputs.length) return;
      this.entryLinks.forEach((link) => {
        const index = this.items.findIndex((item) => item.dataset.blockId === link.dataset.cinemaCollection);
        link.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.lastEntry = link;
          const linked = this.openCollection(index, { focus: true });
          if (!linked) this.panels[index].focus({ preventScroll: true });
        }, { signal });
      });
      // The selected navigation menu is the opening route; optional stories wait for selection.
      this.classList.toggle('esh-tabs-ready', !!this.querySelector('[data-cinema-menu]'));
      this.inputs.forEach((input, index) => {
        input.addEventListener('change', () => {
          if (input.checked) this.openCollection(index);
        }, { signal });
        // The current choice remains a useful shortcut after browsing its story.
        this.cards[index].addEventListener('click', () => {
          if (input.checked) this.openCollection(index);
        }, { signal });
      });
      const back = this.querySelector('.esh-back');
      if (back) {
        back.hidden = false;
        back.addEventListener('click', () => this.closeCollection(), { signal });
      }
      const selected = this.inputs.findIndex((input) => input.checked);
      this.activeCollection = Math.max(0, selected);
      this.collectionOpen = selected >= 0;
      this.classList.toggle('esh-collection-open', this.collectionOpen);
    }

    openCollection(index, options = {}) {
      const panel = this.panels[index];
      if (!panel || !this.inputs[index]) return;
      const same = this.collectionOpen && this.activeCollection === index;
      this.detailAnimation?.cancel();
      this.panels.forEach((other) => {
        if (other !== panel) other.querySelectorAll('video').forEach((video) => this.pauseVideo(video));
      });
      this.activeCollection = index;
      this.collectionOpen = true;
      this.inputs.forEach((input, position) => { input.checked = position === index; });
      this.classList.add('esh-collection-open');
      if (this.collectionStatus) {
        const title = this.cards[index].querySelector('.esh-card-title')?.textContent.trim() || 'Collection';
        this.collectionStatus.textContent = `${title}. Collection ${index + 1} of ${this.cards.length}.`;
      }
      // Native radios also reveal the panel without JavaScript. Keep their focus
      // for arrow-key navigation while guiding the viewport to the next stage.
      this.layoutDirty = true;
      this.measureHeader();
      const linked = !this.dispatchEvent(new CustomEvent('ezm:chapter-select', {
        bubbles: true,
        cancelable: true,
        detail: {
          index, panel,
          title: this.cards[index].querySelector('.esh-card-title')?.textContent.trim() || 'Featured',
          scroll: options.scroll !== false,
          animate: this.motionEnabled && options.animate !== false,
          focus: options.focus === true
        }
      }));
      if (!linked && options.scroll !== false) {
        // Selecting a chapter compacts the sticky cards. Read their new height
        // before scrolling so the selected content clears the whole navigation.
        this.layoutDirty = true;
        this.measureHeader();
        panel.scrollIntoView({ behavior: this.motionEnabled && options.animate !== false ? 'smooth' : 'instant', block: 'start' });
      }
      const content = panel.querySelector('.esh-detail-content');
      if (!linked && !same && this.motionEnabled && options.animate !== false && content?.animate) {
        this.detailAnimation = content.animate([
          { opacity: 0, transform: 'translateY(22px) scale(.992)' },
          { opacity: 1, transform: 'translateY(0) scale(1)' }
        ], { duration: 540, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
      this.scheduleFrame();
      return linked;
    }

    closeCollection() {
      this.detailAnimation?.cancel();
      this.panels.forEach((panel) => panel.querySelectorAll('video').forEach((video) => this.pauseVideo(video)));
      this.inputs.forEach((input) => { input.checked = false; });
      this.collectionOpen = false;
      this.classList.remove('esh-collection-open');
      this.dispatchEvent(new CustomEvent('ezm:chapter-clear', { bubbles: true }));
      this.layoutDirty = true;
      this.measureHeader();
      const entry = this.entryLinks.includes(this.lastEntry) ? this.lastEntry : this.entryLinks[0];
      if (entry) {
        // The previous entry may live inside a submenu closed while browsing.
        for (let disclosure = entry.closest('details'); disclosure && this.contains(disclosure); disclosure = disclosure.parentElement.closest('details')) {
          disclosure.open = true;
        }
        entry.focus({ preventScroll: true });
        this.hero?.scrollIntoView({ behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'start' });
      } else {
        this.inputs[this.activeCollection]?.focus({ preventScroll: true });
        this.cards[this.activeCollection]?.scrollIntoView({ behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'nearest' });
      }
      if (this.collectionStatus) this.collectionStatus.textContent = entry ? 'Back to cinema.' : 'Back to collections.';
      this.scheduleFrame();
    }

    setupCinemaVideo(signal) {
      this.programmaticPauses ||= new WeakSet();
      this.cinemaStates ||= new WeakMap();
      this.cinemaDeck = this.querySelector('[data-cinema-deck]');
      this.cinemaSlides = [...this.querySelectorAll('[data-cinema-slide]')];
      this.cinemaVideos = [...this.querySelectorAll('.esh-cinema-video, video[data-cinema-autoplay="true"]')];
      this.cinemaPause = this.querySelector('[data-cinema-pause]');
      this.cinemaSound = this.querySelector('[data-cinema-sound]');
      this.cinemaStatus = this.querySelector('[data-cinema-status]');
      this.cinemaSlideStatus = this.querySelector('[data-cinema-slide-status]');
      this.cinemaCurrent = this.querySelector('[data-cinema-current]');
      this.cinemaTitle = this.querySelector('[data-cinema-title]');
      this.cinemaPrevious = this.querySelector('[data-cinema-prev]');
      this.cinemaNext = this.querySelector('[data-cinema-next]');
      this.nativeCinemaControls = new Map();

      for (const video of this.cinemaVideos) {
        if (!this.cinemaStates.has(video)) {
          video.muted = true;
          this.cinemaStates.set(video, { userPaused: false, manualPlay: false, pending: false, failed: false, autoBlocked: false });
        }
        const state = this.cinemaStates.get(video);
        video.addEventListener('pause', () => {
          if (!this.programmaticPauses.delete(video)) {
            state.userPaused = true;
            state.manualPlay = false;
            video.autoplay = false;
          }
          this.updateCinemaControls();
        }, { signal });
        video.addEventListener('play', () => {
          if (video.paused) return;
          if (video !== this.cinemaVideo || document.hidden || !this.rootVisible || !this.cinemaVisible) {
            this.pauseVideo(video);
            return;
          }
          state.userPaused = false;
          state.autoBlocked = false;
          if (this.cinemaStatus) this.cinemaStatus.textContent = '';
          this.updateCinemaControls();
        }, { signal });
        video.addEventListener('volumechange', () => this.updateCinemaControls(), { signal });
        video.addEventListener('error', () => {
          state.failed = true;
          video.controls = this.nativeCinemaControls.get(video) ?? true;
          if (video === this.cinemaVideo && this.cinemaStatus) this.cinemaStatus.textContent = 'The film could not load. Please try again later.';
          this.updateCinemaControls();
        }, { signal });
        video.addEventListener('loadeddata', () => {
          state.failed = false;
          if (this.nativeCinemaControls.has(video)) video.controls = false;
          this.updateCinemaControls();
        }, { signal });
      }

      if (this.cinemaPause && this.cinemaSound) {
        this.cinemaPause.addEventListener('click', () => {
          const video = this.cinemaVideo;
          if (!video) return;
          const state = this.cinemaStates.get(video);
          if (video.paused) {
            state.userPaused = false;
            state.manualPlay = true;
            this.playCinema(video, true);
          } else {
            state.userPaused = true;
            state.manualPlay = false;
            video.autoplay = false;
            this.pauseVideo(video);
            this.updateCinemaControls();
          }
        }, { signal });
        this.cinemaSound.addEventListener('click', () => {
          const video = this.cinemaVideo;
          if (!video) return;
          video.muted = !(video.muted || video.volume === 0);
          if (!video.muted && video.volume === 0) video.volume = 1;
          this.updateCinemaControls();
        }, { signal });
        // Only replace native controls once both custom actions are connected.
        this.cinemaVideos.forEach((video) => {
          this.nativeCinemaControls.set(video, video.controls);
          if (!this.cinemaStates.get(video).failed) video.controls = false;
        });
        this.classList.add('esh-cinema-controls-ready');
      }
      this.cinemaPrevious?.addEventListener('click', () => this.selectCinemaSlide(this.activeCinema - 1), { signal });
      this.cinemaNext?.addEventListener('click', () => this.selectCinemaSlide(this.activeCinema + 1), { signal });
      this.cinemaDeck?.addEventListener('keydown', (event) => {
        if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const navigation = event.target.closest?.('[data-cinema-prev], [data-cinema-next]');
        if (event.target !== this.cinemaDeck && !navigation) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.selectCinemaSlide(this.activeCinema + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      let swipeStart = null;
      this.cinemaDeck?.addEventListener('pointerdown', (event) => {
        swipeStart = event.pointerType === 'touch' && !event.target.closest('button, a') ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
      }, { signal, passive: true });
      this.cinemaDeck?.addEventListener('pointerup', (event) => {
        if (!swipeStart || swipeStart.id !== event.pointerId) return;
        const dx = event.clientX - swipeStart.x, dy = event.clientY - swipeStart.y;
        swipeStart = null;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) this.selectCinemaSlide(this.activeCinema + (dx < 0 ? 1 : -1));
      }, { signal, passive: true });
      this.cinemaDeck?.addEventListener('pointercancel', () => { swipeStart = null; }, { signal, passive: true });
      [this.cinemaPrevious, this.cinemaNext].forEach((button) => {
        if (button) button.hidden = this.cinemaSlides.length < 2;
      });
      const selected = this.cinemaSlides.findIndex((slide) => slide.hasAttribute('data-active'));
      if (this.cinemaDeck) this.cinemaDeck.dataset.cinemaReady = 'true';
      this.selectCinemaSlide(Math.max(0, selected), { animate: false, announce: false });
    }

    restoreCinemaControls() {
      this.nativeCinemaControls?.forEach((controls, video) => { video.controls = controls; });
      this.nativeCinemaControls = null;
      [this.cinemaPause, this.cinemaSound, this.cinemaPrevious, this.cinemaNext].forEach((button) => {
        if (button) button.hidden = true;
      });
      if (this.cinemaDeck) delete this.cinemaDeck.dataset.cinemaReady;
      this.classList.remove('esh-cinema-controls-ready');
    }

    selectCinemaSlide(index, options = {}) {
      const count = this.cinemaSlides.length;
      const previous = this.activeCinema;
      this.activeCinema = count ? ((index % count) + count) % count : 0;
      const active = this.cinemaSlides[this.activeCinema];
      this.cinemaAnimation?.cancel();
      this.cinemaTextAnimation?.cancel();
      this.cinemaSlides.forEach((slide, position) => {
        const selected = position === this.activeCinema;
        slide.hidden = !selected;
        slide.toggleAttribute('data-active', selected);
        slide.setAttribute('aria-label', `${position + 1} of ${count}${slide.dataset.title ? `: ${slide.dataset.title}` : ''}`);
      });
      this.cinemaVideo = active?.querySelector('video') || (!count ? this.cinemaVideos[0] : null);
      this.cinemaVisible = !!this.cinemaVideo && this.inViewport(this.cinemaVideo);
      this.cinemaVideos.forEach((video) => {
        const state = this.cinemaStates.get(video);
        const selected = video === this.cinemaVideo;
        video.autoplay = selected && !state.userPaused && !this.motionPreference.matches;
        if (!selected) {
          video.preload = 'none';
          this.pauseVideo(video);
        }
      });
      if (this.cinemaCurrent) this.cinemaCurrent.textContent = String(this.activeCinema + 1).padStart(2, '0');
      if (this.cinemaTitle && active?.dataset.title !== undefined) this.cinemaTitle.textContent = active.dataset.title;
      if (this.cinemaSlideStatus && options.announce !== false && previous !== this.activeCinema) {
        this.cinemaSlideStatus.textContent = `Slide ${this.activeCinema + 1} of ${count}${active?.dataset.title ? `: ${active.dataset.title}` : ''}`;
      }
      if (this.cinemaStatus) this.cinemaStatus.textContent = '';
      this.updateCinemaControls();
      this.syncCinemaPlayback();
      if (active && previous !== this.activeCinema && this.motionEnabled && options.animate !== false && active.animate) {
        this.cinemaAnimation = active.animate([
          { opacity: 0, transform: `translateX(${index < previous ? -28 : 28}px)` },
          { opacity: 1, transform: 'translateX(0)' }
        ], { duration: 360, easing: 'cubic-bezier(.2,.7,.2,1)' });
        this.cinemaTextAnimation = this.cinemaTitle?.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}], {duration:360,easing:'cubic-bezier(.2,.7,.2,1)'});
      }
    }

    updateCinemaControls() {
      const video = this.cinemaVideo;
      const usable = !!video && this.nativeCinemaControls?.has(video) && !this.cinemaStates.get(video).failed;
      if (this.cinemaPause) {
        this.cinemaPause.hidden = !usable;
        this.cinemaPause.dataset.paused = String(!video || video.paused);
        const label = video && !video.paused ? 'Pause film' : 'Play film';
        this.cinemaPause.setAttribute('aria-label', label);
        this.cinemaPause.title = label;
      }
      if (this.cinemaSound) {
        this.cinemaSound.hidden = !usable;
        const muted = !video || video.muted || video.volume === 0;
        this.cinemaSound.dataset.muted = String(muted);
        const label = muted ? 'Turn sound on' : 'Mute sound';
        this.cinemaSound.setAttribute('aria-label', label);
        this.cinemaSound.title = label;
      }
    }

    playCinema(video, manual = false) {
      const state = this.cinemaStates.get(video);
      if (!state || state.pending || state.failed || (!manual && state.autoBlocked)) return;
      const signal = this.events.signal;
      state.pending = true;
      const reject = (error) => {
        if (error?.name === 'AbortError' || signal.aborted) return;
        state.autoBlocked = true;
        if (this.isConnected && video === this.cinemaVideo && this.cinemaStatus) {
          this.cinemaStatus.textContent = manual ? 'The film could not play. Please try again.' : 'Select play to start the film.';
        }
        this.updateCinemaControls();
      };
      try {
        Promise.resolve(video.play()).catch(reject).finally(() => { state.pending = false; });
      } catch (error) {
        state.pending = false;
        reject(error);
      }
    }

    setupCinemaMenu(signal) {
      const disclosures = [...this.querySelectorAll('[data-shop-disclosure]')];
      const menu = this.querySelector('[data-cinema-menu]');
      const peek = this.querySelector('[data-product-peek]');
      const image = peek?.querySelector('[data-peek-image]');
      const title = peek?.querySelector('[data-peek-title]');
      const price = peek?.querySelector('[data-peek-price]');
      const hidePeek = () => { peek?.removeAttribute('data-visible'); };
      const showPeek = (target) => {
        const item = target.closest?.('a, summary');
        if (!item || !menu?.contains(item) || !item.dataset.previewTitle || !peek) { hidePeek(); return; }
        title.textContent = item.dataset.previewTitle;
        price.textContent = item.dataset.previewPrice || '';
        const src = item.dataset.previewImage;
        image.hidden = !src;
        if (src && image.getAttribute('src') !== src) image.src = src;
        peek.setAttribute('data-visible', '');
      };
      menu?.addEventListener('pointerover', (event) => { if (event.pointerType !== 'touch') showPeek(event.target); }, { signal });
      menu?.addEventListener('pointerleave', hidePeek, { signal });
      menu?.addEventListener('focusin', (event) => showPeek(event.target), { signal });
      menu?.addEventListener('focusout', (event) => { if (!menu.contains(event.relatedTarget)) hidePeek(); }, { signal });
      image?.addEventListener('error', () => { image.hidden = true; }, { signal });
      const closeMenus = () => { disclosures.forEach((details) => { details.open = false; }); hidePeek(); };
      document.addEventListener('pointerdown', (event) => { if (!menu?.contains(event.target)) closeMenus(); }, { signal });
      menu?.addEventListener('click', (event) => { if (event.target.closest('a')) closeMenus(); }, { signal });
      menu?.addEventListener('focusout', (event) => { if (event.relatedTarget && !menu.contains(event.relatedTarget)) closeMenus(); }, { signal });
      disclosures.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          const parent = details.parentElement.closest('details');
          disclosures.forEach((other) => {
            if (other !== details && other.parentElement.closest('details') === parent) other.open = false;
          });
        }, { signal });
        details.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !details.open) return;
          event.preventDefault();
          event.stopPropagation();
          details.open = false;
          details.querySelector(':scope > summary')?.focus({ preventScroll: true });
          hidePeek();
        }, { signal });
      });
    }

    syncCinemaPlayback() {
      const video = this.cinemaVideo;
      const state = video && this.cinemaStates.get(video);
      if (!state || !this.isConnected || state.userPaused || state.failed || document.hidden || !this.rootVisible || !this.cinemaVisible) {
        if (video) this.pauseVideo(video);
        return;
      }
      if ((this.motionPreference.matches && !state.manualPlay) || !video.paused) return;
      this.playCinema(video);
    }

    setupViewport() {
      if (!('IntersectionObserver' in window)) return;
      this.viewportObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === this) {
            this.rootVisible = entry.isIntersecting;
            if (entry.isIntersecting) { this.scheduleFrame(); this.syncCinemaPlayback(); }
            else this.pauseVideos();
          } else if (entry.target === this.hero) {
            this.heroVisible = entry.isIntersecting;
            if (entry.isIntersecting) this.animateOpening();
          } else {
            if (entry.target === this.cinemaVideo) this.cinemaVisible = entry.isIntersecting;
            if (!entry.isIntersecting || (this.cinemaVideos.includes(entry.target) && entry.target !== this.cinemaVideo)) this.pauseVideo(entry.target);
            else if (entry.target === this.cinemaVideo) this.syncCinemaPlayback();
          }
        }
      });
      this.viewportObserver.observe(this);
      if (this.hero) this.viewportObserver.observe(this.hero);
      this.videos.forEach((video) => this.viewportObserver.observe(video));
    }

    configureMotion() {
      this.revealObserver?.disconnect();
      this.motionEnabled = this.animationAllowed && !this.motionPreference.matches;
      if (this.cinemaVideo) {
        const state = this.cinemaStates.get(this.cinemaVideo);
        this.cinemaVideo.autoplay = !this.motionPreference.matches && !state.userPaused;
        if (this.motionPreference.matches) this.pauseVideo(this.cinemaVideo);
        else this.syncCinemaPlayback();
      }
      this.classList.toggle('esh-motion', this.motionEnabled && 'IntersectionObserver' in window);
      if (!this.motionEnabled) this.cancelAnimations();
      else this.animateOpening();
      if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
      this.revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('esh-revealed');
          this.revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
      [...this.items, ...this.querySelectorAll('[data-esh-reveal]')].forEach((item) => {
        if (!item.classList.contains('esh-revealed')) this.revealObserver.observe(item);
      });
    }

    animateOpening() {
      if (!this.motionEnabled || !this.heroVisible || this.openingAnimated) return;
      this.openingAnimated = true;
      this.openingAnimations = [...this.querySelectorAll('.esh-cinema-intro, .esh-cinema-footer')].flatMap((node, index) => {
        if (!node.animate) return [];
        return node.animate([
          { opacity: 0, transform: 'translateY(16px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 650, delay: index * 90, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
      });
    }

    cancelAnimations() {
      this.detailAnimation?.cancel();
      this.cinemaAnimation?.cancel();
      this.openingAnimations?.forEach((animation) => animation.cancel());
      this.cinemaTextAnimation?.cancel();
      this.openingAnimations = [];
    }

    pauseVideo(video) {
      if (video.paused) return;
      // Pause events are asynchronous. Remember which pauses came from us so
      // scrolling never overrides a visitor's explicit pause or sound choice.
      this.programmaticPauses ||= new WeakSet();
      this.programmaticPauses.add(video);
      video.pause();
    }

    pauseVideos() {
      this.videos?.forEach((video) => this.pauseVideo(video));
    }

    inViewport(node) {
      const rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
    }

    observeHeader() {
      this.headerResize?.disconnect();
      this.headerChanges?.disconnect();
      this.headerRoot = document.getElementById('x-header-container') || document.querySelector('#shopify-section-header, header[role="banner"]');
      this.headerContent = document.getElementById('sticky-header-content') || this.headerRoot;
      const section = this.headerRoot?.closest('.section-header') || this.headerRoot;
      const nodes = [...new Set([this.headerRoot, this.headerContent, section, document.getElementById('x-announcement')].filter(Boolean))];
      const refresh = () => { this.layoutDirty = true; this.scheduleFrame(); };
      if ('ResizeObserver' in window) {
        this.headerResize = new ResizeObserver(refresh);
        nodes.forEach((node) => this.headerResize.observe(node));
        if (this.tabBar) this.headerResize.observe(this.tabBar);
      }
      if ('MutationObserver' in window) {
        this.headerChanges = new MutationObserver(refresh);
        nodes.forEach((node) => this.headerChanges.observe(node, { attributes: true, attributeFilter: ['class', 'style'] }));
      }
      this.layoutDirty = true;
    }

    setProperty(name, value) {
      if (this.cssValues.get(name) === value) return;
      this.cssValues.set(name, value);
      this.style.setProperty(name, value);
    }

    measureHeader() {
      const rect = this.headerContent?.getBoundingClientRect();
      if (this.layoutDirty) {
        const main = this.closest('main');
        const wrapper = this.closest('.shopify-section') || this;
        const first = main && [...main.children].find((node) => node.matches('.shopify-section, ezm-story-cinema') && node.getBoundingClientRect().height > 0);
        const firstSection = main ? first === wrapper || first === this : !this.previousElementSibling;
        const overlay = this.headerMode === 'overlay' || (this.headerMode === 'auto' && firstSection && !!this.headerRoot?.classList.contains('transparent-header'));
        // Read geometry before writing styles; only scrolling header position stays dynamic.
        const overlayHeight = Math.ceil(rect?.height || this.headerFallback);
        const tabsHeight = Math.ceil(this.tabBar?.getBoundingClientRect().height || 0);
        this.themeHeaderHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--height-header')) || 0;
        this.classList.toggle('esh-header-overlay', overlay);
        this.setProperty('--esh-overlay-height', `${overlayHeight}px`);
        this.setProperty('--esh-tabs-height', `${tabsHeight}px`);
        if (this.hero) {
          // Include overlay padding first. Scroll offsets keep this measurement
          // stable when the visitor scrolls or a theme uses a nested scroller.
          let openingTop = this.hero.getBoundingClientRect().top + window.scrollY;
          for (let ancestor = this.hero.parentElement; ancestor && ancestor !== document.body && ancestor !== document.documentElement; ancestor = ancestor.parentElement) {
            openingTop += ancestor.scrollTop;
          }
          if (openingTop >= innerHeight) {
            const spacing = parseFloat(getComputedStyle(this).getPropertyValue('--esh-space-top')) || 0;
            openingTop = spacing + (overlay ? overlayHeight : Math.max(0, rect?.height || this.headerFallback));
          }
          this.setProperty('--esh-opening-top', `${Math.max(0, Math.round(openingTop))}px`);
        }
        this.layoutDirty = false;
      }
      const visibleBottom = rect && rect.bottom > 0 && rect.top < innerHeight ? Math.max(0, rect.bottom) : 0;
      const offset = this.headerContent ? visibleBottom : this.headerFallback;
      this.setProperty('--esh-anchor-offset', `${Math.ceil(Math.max(offset, this.themeHeaderHeight || 0))}px`);
    }

    scheduleFrame() {
      if (this.frame || !this.isConnected || !this.rootVisible || document.hidden) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.isConnected && this.rootVisible) this.measureHeader();
      });
    }

    followAnchor(event) {
      const link = event.target.closest?.('a');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const href = link.getAttribute('href');
      if (!href?.startsWith('#')) return;
      const destination = document.getElementById(href.slice(1));
      if (!destination || !this.contains(destination)) return;
      event.preventDefault();
      this.measureHeader();
      destination.focus({ preventScroll: true });
      destination.scrollIntoView({ behavior: this.motionEnabled ? 'smooth' : 'instant', block: 'start' });
    }
  }

  customElements.define(tag, EZMStoryCinema);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(tag).forEach((section) => section.connectedCallback());
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(tag).forEach((section) => section.disconnectedCallback());
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezm-switching-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ezm-scene-banner')) {
    customElements.define('ezm-scene-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.frames = Array.from(this.querySelectorAll('.es-frame'));
        this.motionButton = this.querySelector('.es-motion');
        this.currentIndex = Math.max(0, this.frames.findIndex(frame => frame.classList.contains('is-active')));
        this.interval = Math.max(500, Number(this.dataset.interval) || 1750);
        this.autoplay = this.dataset.autoplay === 'true';
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motionQuery.matches;
        this.inView = false;
        this.editorSelected = false;
        this.epoch = 0;
        this.motionButton?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.reflectControl();
          this.schedule();
        }, { signal });
        this.motionQuery.addEventListener('change', event => {
          if (event.matches) this.paused = true;
          this.reflectControl();
          this.schedule();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.frames.findIndex(frame => frame.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.stop();
          this.show(index);
          this.preload(index);
          this.reflectControl();
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => {
          this.editorSelected = false;
          this.reflectControl();
          this.schedule();
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.schedule();
          }, { threshold:0 });
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.schedule();
        }
        this.reflectControl();
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
      }

      canPlay() {
        return this.isConnected && this.autoplay && !this.paused && !this.editorSelected && this.inView && !document.hidden && this.frames.length > 1;
      }

      reflectControl() {
        if (!this.motionButton) return;
        this.motionButton.hidden = !this.autoplay || this.frames.length < 2 || this.editorSelected;
        this.motionButton.dataset.paused = String(this.paused);
        this.motionButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      }

      stop() {
        window.clearTimeout(this.timer);
        this.epoch += 1;
      }

      preload(index) {
        const image = this.frames[index]?.querySelector('img');
        if (image) image.loading = 'eager';
        return image;
      }

      show(index) {
        this.frames.forEach((frame, frameIndex) => frame.classList.toggle('is-active', frameIndex === index));
        this.currentIndex = index;
      }

      schedule() {
        this.stop();
        if (!this.canPlay()) return;
        this.preload((this.currentIndex + 1) % this.frames.length);
        this.timer = window.setTimeout(() => this.advance(), this.interval);
      }

      async advance() {
        const epoch = this.epoch;
        for (let offset = 1; offset < this.frames.length; offset += 1) {
          const next = (this.currentIndex + offset) % this.frames.length;
          const image = this.preload(next);
          if (image && (!image.complete || !image.naturalWidth)) {
            try { await image.decode(); } catch (error) {
              if (epoch !== this.epoch || !this.canPlay()) return;
              continue;
            }
          }
          if (epoch !== this.epoch || !this.canPlay()) return;
          if (image && !image.naturalWidth) continue;
          this.show(next);
          break;
        }
        if (epoch === this.epoch && this.canPlay()) this.schedule();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezm-universal-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ezm-universal-tabs')) {
    customElements.define('ezm-universal-tabs', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.events?.abort();
        this.gesture = null;
      }

      setup() {
        this.events?.abort();
        this.events = new AbortController();
        const { signal } = this.events;
        this.tabs = Array.from(this.querySelectorAll('.eut-tab'));
        this.panels = Array.from(this.querySelectorAll('.eut-panel'));
        const tablist = this.tablist = this.querySelector('.eut-tabs');
        if (!tablist || this.tabs.length < 1 || this.tabs.length !== this.panels.length) return;
        tablist.setAttribute('role', 'tablist');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.gesture = null;
        this.suppressClickUntil = 0;

        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
          panel.tabIndex = 0;
        });
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.activate(index);
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            let next = index;
            if (event.key === ' ') {
              event.preventDefault();
              this.activate(index);
              return;
            }
            if (event.key === 'ArrowRight') next += direction;
            else if (event.key === 'ArrowLeft') next -= direction;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.activate(next);
            this.tabs[next].focus();
          }, { signal });
        });

        // Selecting a block in Shopify's editor reveals its panel.
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex((panel) => panel.dataset.blockId === String(event.detail?.blockId));
          if (index >= 0) this.activate(index);
        }, { signal });

        const panelContainer = this.querySelector('.eut-panels');
        panelContainer.classList.add('eut-panels--enhanced');
        if (this.tabs.length > 1) this.bindSwipe(panelContainer, signal);
        const navigation = this.querySelector('.eut-mobile-nav');
        if (navigation) {
          navigation.hidden = this.tabs.length < 2;
          navigation.querySelectorAll('[data-step]').forEach((button) => {
            button.addEventListener('click', () => this.step(Number(button.dataset.step)), { signal });
          });
        }
        window.addEventListener('resize', () => {
          this.gesture = null;
          this.revealActiveTab();
        }, { signal });
        this.classList.toggle('eut-ready', this.tabs.length > 1);
        tablist.hidden = false;
        this.activate(Math.min(this.activeIndex || 0, this.tabs.length - 1), false);
      }

      bindSwipe(container, signal) {
        container.addEventListener('pointerdown', (event) => {
          // A second finger cancels the gesture so pinch zoom remains native.
          if (!event.isPrimary) {
            this.gesture = null;
            return;
          }
          if (!this.mobileQuery.matches || !['touch', 'pen'].includes(event.pointerType)) return;
          if (event.target.closest('input, textarea, select, video, [contenteditable]')) return;
          this.suppressClickUntil = 0;
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
        }, { signal, passive: true });

        container.addEventListener('pointermove', (event) => {
          const gesture = this.gesture;
          if (!gesture || gesture.id !== event.pointerId) return;
          const x = Math.abs(event.clientX - gesture.x);
          const y = Math.abs(event.clientY - gesture.y);
          // Once vertical scrolling starts, this contact cannot change tabs.
          if (!gesture.horizontal && y > 12 && y >= x) this.gesture = null;
          else if (x > 16 && x > y * 1.4) gesture.horizontal = true;
        }, { signal, passive: true });

        container.addEventListener('pointerup', (event) => {
          const gesture = this.gesture;
          this.gesture = null;
          if (!gesture || gesture.id !== event.pointerId || !this.mobileQuery.matches) return;
          const x = event.clientX - gesture.x;
          const y = event.clientY - gesture.y;
          const threshold = Math.max(44, Math.min(72, container.clientWidth * 0.16));
          // Ignore taps, short drags and diagonal/vertical page gestures.
          if (Math.abs(x) < threshold || Math.abs(x) < Math.abs(y) * 1.4) return;
          this.suppressClickUntil = performance.now() + 500;
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          this.step((x < 0 ? 1 : -1) * direction);
        }, { signal, passive: true });

        container.addEventListener('pointercancel', () => { this.gesture = null; }, { signal, passive: true });
        container.addEventListener('click', (event) => {
          // A swipe beginning on a product or photograph must not open its link.
          if (event.detail !== 0 && performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { signal, capture: true });
      }

      step(direction) {
        this.activate((this.activeIndex + direction + this.tabs.length) % this.tabs.length);
      }

      revealActiveTab() {
        if (!this.mobileQuery?.matches) return;
        const tab = this.tabs[this.activeIndex];
        if (!tab) return;
        const strip = this.tablist.getBoundingClientRect();
        const selected = tab.getBoundingClientRect();
        const delta = selected.left < strip.left ? selected.left - strip.left : Math.max(0, selected.right - strip.right);
        // Scroll only the tab strip, leaving the page's vertical position alone.
        if (delta) this.tablist.scrollBy({ left: delta, behavior: 'auto' });
      }

      activate(index, announce = true) {
        const previousPanel = this.panels[this.activeIndex];
        const moveFocus = previousPanel && this.activeIndex !== index && previousPanel.contains(document.activeElement);
        this.activeIndex = index;
        if (moveFocus) this.tabs[index].focus({ preventScroll: true });
        this.tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[position].toggleAttribute('data-inactive', !active);
          this.panels[position].inert = !active;
          this.panels[position].setAttribute('aria-hidden', String(!active));
        });
        const position = this.querySelector('.eut-position');
        if (position) position.textContent = `${index + 1} / ${this.tabs.length}`;
        const status = this.querySelector('.eut-status');
        if (status && announce) {
          const title = this.tabs[index].querySelector('.eut-tab-label').textContent.trim();
          status.textContent = `${title}. Tab ${index + 1} of ${this.tabs.length}.`;
        }
        this.revealActiveTab();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
